import { observable, action } from 'mobx';
// import useMount from '@src/utils/hooks/use-mount';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import TinyInputStore from '@src/components/tiny-input/store';
import InputStore from '@src/utils/store/input-store';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import { go } from '@src/utils/promise/index';
import AntdMessage from '@src/components/antd/message';
import $$tracker from '@src/tracker';
import { getUtmSource } from '@src/utils/device';
import { sendSemReport } from '@src/utils/sem';

// import Toast from '@src/components/toast';

class FormModalStore extends BaseModalStore {
  /** 协议勾选 */
  @observable agreementChecked = false;
  /** 平台弹窗列表 */
  @observable
  platformPopArr = [
    { id: 'Android', name: '安卓', icon: require('./images/android.png'), selectedIcon: require('./images/android_2.png'), selected: false },
    { id: 'iOS', name: '苹果', icon: require('./images/ios.png'), selectedIcon: require('./images/ios_2.png'), selected: false },
    { id: 'Harmony', name: '鸿蒙', icon: require('./images/harmony.png'), selectedIcon: require('./images/harmony_2.png'), selected: false },
    { id: 'PC', name: '电脑端', icon: require('./images/pc.png'), selectedIcon: require('./images/pc_2.png'), selected: false }
  ];
  subLoading = false;
  // 手机号
  phoneInputStore = new InputStore();
  // 验证码
  vcCode = new TinyInputStore();

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /** 选择平台 */
  selectPlatform = index => {
    this.platformPopArr[index].selected = !this.platformPopArr[index].selected;
  };
  changeAgreementChecked = () => {
    this.agreementChecked = !this.agreementChecked;
  };

  /** 关闭弹窗 */
  onFormModalClose = () => {
    this.onClickClose();
    if (this.closeCb) this.closeCb();
    this.onClose();
  };

  /** 切换到二维码弹窗 */
  changeToQrcodeModal = () => {
    this.onFormModalClose();
    this.goToQrcodeModal();
    $$tracker.clickPopupQrcodeReservation();
  };
  // /** 发送验证码 */
  // onSendVCRequest = () => {
  //   this.sendCode(this.phoneInputStore.value);
  // };

  /** 发送短信验证码-(前置-人机校验) */
  @action.bound
  @captchaHandlerDecorate('zt')
  async onSendVCRequest(authParams) {
    $$tracker.clickGetVerifyCode();
    const [_data, err] = await go(this.$ztService.getPhoneCode(authParams));
    if (err) {
      AntdMessage.error(err?.message || '发送失败！');
      return false;
    }
    return true;
  }
  /** 立即预约 */
  submitReservation = async () => {
    if (this.subLoading) return;
    const a = 'PC游戏预约';
    // 获取用户输入的验证码
    const code = this.vcCode.value;
    // 设备ID（预留字段，当前为空）
    const device_id = '';
    // 被邀请人UID（预留字段，当前为空）
    const invitee_uid = '';
    // 操作来源，固定为pc端
    const operate_from = 'pc';
    // 获取用户输入的手机号
    const phone = this.phoneInputStore.value;
    // 获取已选中的平台，拼接成逗号分隔的字符串
    const platform = this.platformPopArr
      .filter(item => item.selected)
      .map(item => item.id)
      .join(',');
    // 用户代理中的操作系统信息（预留字段，当前为空）
    const ua_os = '';
    const utm_source = getUtmSource('utm_source') || '';

    if (!platform) {
      AntdMessage.error('请选择至少一个设备');
      return;
    }
    if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
      AntdMessage.error('请输入正确的手机号');
      return;
    }
    if (!code || code.length !== 6) {
      AntdMessage.error('请输入正确的验证码');
      return;
    }
    if (!this.agreementChecked) {
      AntdMessage.error('请阅读并同意服务使用协议和隐私政策');
      return;
    }
    this.subLoading = true;
    const [data, err] = await go(this.$ztService.subscribe('PC游戏预约', code, device_id, invitee_uid, operate_from, phone, platform, ua_os, utm_source));
    this.subLoading = false;
    if (err) {
      $$tracker.phoneReservation('失败');
      AntdMessage.error(err.message || '预约失败！');
      return false;
    }
    void sendSemReport('btForm');
    $$tracker.phoneReservation('成功');
    if (data?.is_frist) AntdMessage.success('预约成功！');
    this.onFormModalClose();
    if (this.reservationSuccessCb) this.reservationSuccessCb();

    return true;
  };

  use(onClose) {
    super.use();
    if (onClose) {
      this.onClose = onClose;
    }
    // useMount(() => this.getQrcode());
  }
}

export default FormModalStore;
